/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { ref, onMounted, createApp, nextTick, watch, reactive } from "vue";
import Tabs from "@/class/Tabs";

export default function usePopup() {
  let content = ref("");
  let articleID = ref("");
  let show = ref(false);
  let pos = reactive({ x: 0, y: 0 });

  // watch(
  //   () => {
  //     return articleID.value;
  //   },
  //   (state, preState) => {
  //     if (!state) {
  //       show.value = false;
  //       return false;
  //     }
  //     show.value = true;

  //     fetchContent();
  //   }
  // );

  onMounted(() => {
    var testUl = document.getElementById("layout-article");

    testUl!.addEventListener("mousemove", function (event) {
      var ev = event || window.event;

      if (
        (ev.target! as HTMLElement).nodeName.toLowerCase() == "atention" ||
        (ev.target! as HTMLElement).parentNode!.nodeName.toLowerCase() ==
          "atention"
      ) {
        show.value = true;
        pos.x = ev.pageX;
        pos.y = ev.pageY;

        var target = ev.target as HTMLInputElement;
        content.value = target!.getAttribute("data-content") as string;
      } else {
        show.value = false;
      }
    });
  });

  return { content, show, pos };
}
